import React from "react";
import { ErrorBoundary } from "react-error-boundary";
import SpinnerWithLoadMask from "components/SpinnerWithLoadMask";
import DocumentSummaryContent from "layout/documentSummary/DocumentSummaryContent";
import ErrorFallbackModal from "components/Modal/ErrorFallbackModal";

const DocumentSummary = () => {
  return (
    <ErrorBoundary FallbackComponent={ErrorFallbackModal}>
      <SpinnerWithLoadMask opacity={0.7} fullScreen />
      <DocumentSummaryContent />
    </ErrorBoundary>
  );
};

export default DocumentSummary;
